export const name = 'scrollToAnchor' as const
export const SamePageScrollSymbol = Symbol('SamePageScroll')
export const AnchorCompIdProviderSymbol = Symbol('AnchorCompIdProvider')
export const ScrollToAnchorHandlerProviderSymbol = Symbol('ScrollToAnchorHandlerProvider')
